/*
 * types/services/dr2am.tasks.orders.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbOrder} from './PbOrder';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceUpdateOrdersResponse model module.
 * @module model/ServiceUpdateOrdersResponse
 * @version version not set
 */
export class ServiceUpdateOrdersResponse {
  /**
   * Constructs a new <code>ServiceUpdateOrdersResponse</code>.
   * @alias module:model/ServiceUpdateOrdersResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceUpdateOrdersResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceUpdateOrdersResponse} obj Optional instance to populate.
   * @return {module:model/ServiceUpdateOrdersResponse} The populated <code>ServiceUpdateOrdersResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceUpdateOrdersResponse();
      if (data.hasOwnProperty('order'))
        obj.order = PbOrder.constructFromObject(data['order']);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbOrder} order
 */
ServiceUpdateOrdersResponse.prototype.order = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceUpdateOrdersResponse.prototype.state = undefined;


